import { LANGUAGE } from "@/common/utils/constants.js";

export const HOME_DOCX = {
	[LANGUAGE.en.short]: {
		digitalReference: "Digital Reference",
		catalog: "Catalogue",
		published: "Published",
	},
	[LANGUAGE.de.short]: {
		digitalReference: "Digitale Referenz",
		catalog: "Katalog",
		published: "Veröffentlicht",
	},
	[LANGUAGE.fr.short]: {
		digitalReference: "Référence numérique",
		catalog: "Catalogue",
		published: "Publié",
	},
	[LANGUAGE.it.short]: {
		digitalReference: "Riferimento digitale",
		catalog: "Catalogare",
		published: "Pubblicato",
	},
	[LANGUAGE.ja.short]: {
		digitalReference: "デジタルリファレンス",
		catalog: "カタログ",
		published: "発行済み",
	},
	[LANGUAGE.es.short]: {
		digitalReference: "Referencia digital",
		catalog: "Catálogo",
		published: "Publicado",
	},
}
